import type { FaireProductEntity } from "../../entity_types/product";

export const p_erikk6ji0q: FaireProductEntity = {
  token: "p_erikk6ji0q",
  type: "product",
  name: "Thai Kitchen & Garden Shears",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/d6d2320c424bb6f2a40c8be4e63a4e6b2e30ec69f485e2f52319235b02e0e181.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57630f3c060f84144507a1dec37c219eaffecbbb32c82ccba08dffdd038e0945.jpeg",
    "https://cdn.faire.com/fastly/0e7d85bdba429332755e793f8a9b6899842ae06d35fd6d9d11b70c9b7a194816.jpeg",
    "https://cdn.faire.com/fastly/84ef4e3823a7bc2cdb983f333c79411a3b8ba8c883b12085992393a4e7d1edfb.jpeg",
    "https://cdn.faire.com/fastly/2f2e55a6c01b7f6d51ecfc7c6fe549b3502c701c0bcc77348e0ff3458fc3a39e.jpeg",
    "https://cdn.faire.com/fastly/a86430b37c57186a841f4c1ab4c310a78810504abc2b9320cf7b9e435c9fc919.jpeg",
  ],
  priceDollars: 24,
  description:
    "Snip basil leaves or clip some tulips with these Thai kitchen and garden shears, and you may feel a sense of adventure knowing they were made in the tradition of Thai sword makers. These shears are sharp enough for everything from gardening to kitchen prep, with stainless steel blades and Pradu wood handles. Packaged in a printed cloth drawstring bag, these shears are perfect for your favorite home gardeners and chefs.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:03.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
